var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReSyncConnectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 5.625,
    stroke: "#1B51A4",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50831 15.9907L8.2417 15.7574C8.24169 15.7574 8.24168 15.7574 8.24167 15.7574C7.66531 15.2475 7.26107 14.6659 7.02852 14.0126C6.79565 13.3583 6.67925 12.6986 6.67925 12.0334C6.67925 10.8028 7.04781 9.70825 7.78499 8.74937C8.51892 7.79471 9.4752 7.16152 10.6542 6.84963V8.22465C9.85566 8.5148 9.21188 9.00706 8.72319 9.70122C8.23281 10.3978 7.98758 11.1753 7.98758 12.0334C7.98758 12.535 8.08234 13.0227 8.27181 13.4964C8.46139 13.9704 8.75685 14.4079 9.15791 14.8089L9.32458 14.9756L9.34591 14.9969V14.9667V13.3459H10.6542V17.3209H6.67925V16.0126H8.50008H8.53335L8.50831 15.9907ZM14.6542 9.03341V10.6542H13.3459V6.67925H17.3209V7.98758H15.5001H15.4668L15.4918 8.00949L15.7582 8.24255C16.3014 8.78584 16.6975 9.37599 16.9468 10.013C17.1962 10.6504 17.3209 11.3017 17.3209 11.9667C17.3209 13.1974 16.9523 14.2919 16.2152 15.2508C15.4812 16.2055 14.525 16.8386 13.3459 17.1505V15.7755C14.1445 15.4854 14.7883 14.9931 15.277 14.2989C15.7674 13.6024 16.0126 12.8249 16.0126 11.9667C16.0126 11.4651 15.9178 10.9774 15.7284 10.5038C15.5388 10.0298 15.2433 9.5923 14.8423 9.19124L14.6756 9.02458L14.6542 9.00324V9.03341Z",
    fill: "#1B51A4",
    stroke: "#1B51A4",
    strokeWidth: 0.025
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReSyncConnectionIcon);
export default __webpack_public_path__ + "static/media/re-sync-connection-icon.7757ad3eb3aa161db9443d6f0b15527e.svg";
export { ForwardRef as ReactComponent };